<div class="btn-group">
  <button #manageAlertBtn class="btn btn-medium-dark dropdown-toggle" type="button" id="manageAlertButton" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
    Manage Alert
  </button>
  <div #dm class="dropdown-menu dropdown-menu-lg-end" style="min-width: 25rem;">
    <form [formGroup]="alertFormGroup" class="font-size-sm">
      <div class="form-check form-check-inline mx-3">
        <input class="form-check-input align-baseline" type="checkbox" id="ReceiveUpdatesChbx" formControlName="hasSubscription" value="Crime Gun" (change)="onSubscribeChange($event)">
        <label class="form-check-label" for="ReceiveUpdatesChbx">{{ checkboxLabel }}</label>
      </div>
      <div *ngIf="alertFormGroup.get('hasSubscription').value"><hr class="dropdown-divider" /></div>
      <div *ngIf="alertFormGroup.get('hasSubscription').value" class="m-3">
        <label for="alertNoteId" class="fw-bold">Alert Note:</label>
        <textarea [rows]="4" id="alertNoteId" class="form-control" formControlName="alertNote" maxlength="150"></textarea>
        <div class="invalid-feedback" *ngIf="alertFormGroup.get('alertNote').invalid" aria-invalid="true">
          Alert note can have a maximum of 150 characters.
        </div>
        <button [hidden]="!displayEditButton" class="btn btn-active btn-sm mt-2" (click)="onEditAlertNote()">Edit Alert Note</button>
      </div>
    </form>
  </div>
</div>
<p-toast position="center" [preventOpenDuplicates]="true"></p-toast>
<p-dialog header="Alert Note (Optional)" [(visible)]="displayAlertNote" (onHide)="onCloseAlertNote($event)" [style]="{width: '30vw'}" [breakpoints]="{'992px': '50vw', '576px': '75vw'}" [maximizable]="true" [modal]="true">
  <ng-template pTemplate="body">
    <textarea [rows]="4" aria-label="Enter a note for the alert." id="alertNoteId" class="form-control" [(ngModel)]="tempAlertNote" maxlength="150"></textarea>
    <div class="text-danger font-size-sm">
      Alert note can have a maximum of 150 characters.
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <button type="button" pButton label="Close" (click)="onCloseAlertNote($event)" title="Close"></button>
    <button type="button" pButton label="Save" (click)="onSubmitAlertNote($event)" title="Save"></button>
  </ng-template>
</p-dialog>
